import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import LeftArrow from '../../../../../asset/svg/leftArrow.svg';
import '../../../../../scss/pages/Attendance/Component/Attendance/ViewedCardData/viewedCardData.scss'
import { ADMIN_PATH, ATTENDANCE_HISTORY_PATH } from '../../../../../utils/Constants';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Box } from '@mui/system';
import { Typography } from '@mui/material';
import AttendanceRequest from '../AttendanceRequest/attendanceRequest';
import AttendanceReport from '../AttendanceReport/attendanceReport';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', }}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        "aria-controls": `full-width-tabpanel-${index}`
    };
}

function ViewedCardData() {
    const navigate = useNavigate();
    const [value, setValue] = useState(0);
    const [windowSize, setWindowSize] = useState({
        width: undefined,
        height: undefined,
    });

    useEffect(() => {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
        window.addEventListener("resize", handleResize); handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    document.documentElement.style.setProperty('--screen-width', windowSize.width + 'px');

    const handleBack = () => {
        navigate(ADMIN_PATH)
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleNaviagteHistoryPage = () => {
        navigate(ATTENDANCE_HISTORY_PATH)
    }
    return (
        <div className='viewedCardDataAttendance-Container'>
            <div className='viewedCardDataAttendance-Container_header'>
                <div>
                    {/* <img className='viewedCardDataAttendance-Container_header_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp; */}
                    <span className='viewedCardDataAttendance-Container_header_content'>Attendance</span>
                </div>
            </div>
            <div className='viewedCardDataAttendance-Container_tabs-Container'>
                <Tabs value={value} onChange={handleChange} style={{ padding: 0 }}>
                    <Tab label="Request" {...a11yProps(0)} style={value == 0 ? { color: 'black', padding: '5px', background: '#FFFFFF', borderRadius: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 500, fontSize: '10px', } : { color: 'white', display: 'flex', alignItems: 'center', justifyContent: "center", padding: '5px', background: 'rgba(255, 255, 255, 0.1)', fontWeight: 500, fontSize: '10px', borderRadius: '40px' }} />
                    {/* <Tab label="Report" {...a11yProps(1)} style={value == 1 ? { color: 'black', background: '#FFFFFF', borderRadius: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 500, fontSize: '10px', } : { color: 'white', display: 'flex', alignItems: 'center', justifyContent: "center", background: 'rgba(255, 255, 255, 0.1)', fontWeight: 500, fontSize: '10px', borderRadius: '40px' }} /> */}
                </Tabs>
                <div className='viewedCardDataAttendance-Container_tabs-Container_history-Container'>
                    <Typography className='viewedCardDataAttendance-Container_tabs-Container_history-Container_history-link' onClick={handleNaviagteHistoryPage}>History</Typography>
                </div>
            </div>
            <div className='viewedCardDataAttendance-Container_tabPanel-Container'>
                <TabPanel value={value} index={0} >
                    <AttendanceRequest />
                </TabPanel>
                {/* <TabPanel value={value} index={1} >
                <AttendanceReport />
            </TabPanel> */}
            </div>
        </div>
    )
}

export default ViewedCardData;